import { useEffect, useState } from "react";
import { FETCH_BILL_DETAILS } from "../../../../../FTTX/features/Orp/utils/constant";
import { useLanguage } from "../../../../../Shared/cache/context/LanguageProvider";
import { useLoading } from "../../../../../Shared/cache/context/LoadingProvider";
import useFetch from "../../../../../Shared/cache/useFetch";
import { GET, LANGUAGE_PREFIX, ORP_TRANSLATION, TRANSLATION } from "../../../../../Shared/helper/constants";
import { eventEmitter } from "../../../../../Shared/service/google-analytics.service";
import { ORP } from "../../../helper/constants";
import ToastMsg from "../../../shared/components/ToastMsg/ToastMsg";
import { getBillAmount, getOtp, resendOtp, validateMsidnViaAccount, verifyOtp } from "../../../shared/service";
import './OtpModal.scss';
import { generateMsisdn } from "../../../../../Shared/helper/helper";

const OtpModal = ({ msisdn, toggleModalEvent, billSummaryEvent, sendBillInfo }) => {
    const [showOtpModal, setShowOtpModal] = useState(true);
    const [showAccountModal, setShowAccountModal] = useState(false);
    const [isOtpSent, setIsotpSent] = useState(false);
    const [otpRefId, setOtpRefId] = useState('');
    const [otp, setOtp] = useState();
    const [accountNumber, setAccountNumber] = useState('');
    const [unbilledAmount, setUnbilledAmout] = useState('');
    const [OutstandingAmount, setOutstandingAmount] = useState('');
    const [otpErrorMsg, setOtpErrorMsg] = useState('');
    const [accountErrorMsg, setAccountErrorMsgs] = useState('');
    const { showLoader, hideLoader } = useLoading();
    const [toastMsg, setToastMsg] = useState(null);
    const [token, setToken] = useState("");
    const [translation, setTranslation] = useState({
        verifyAccount: "Verify your account",
        otpWillbeSent: "OTP will be sent to your mobile No.",
        resend: "RESEND",
        facingProblem: "Still Facing Problem?",
        didntReceiveOtp: "Didn't receive OTP? ",
        fetchViaAccount: "Fetch Via Account Number",
        getOutstanding: "Get Outstanding",
        enterAccountNo: "Please enter your account number",
    })
    const { languagePrefix } = useLanguage();
    const { data: data } = useFetch({
        url: ORP_TRANSLATION.replace(LANGUAGE_PREFIX, languagePrefix),
        method: GET,
        key: TRANSLATION,
        initialEnabled: false,
        cache: {
            enabled: true,
            ttl: 3600
        }
    });
    useEffect(() => {
        if (data?.otpModal) setTranslation(data?.otpModal)
    }, [data])

    const sendOtp = (event) => {
        event.preventDefault();

        let postRequestData = {
            // typeOfNumber: "PREP",
            text: msisdn,
            text1: null,
            otpAction: "INVOICE",
            flowType: FETCH_BILL_DETAILS
        };
        let postRequest = {
            data: postRequestData,
        };

        showLoader();
        getOtp(postRequest).then((res) => {
            let data;
            res = res?.data;
            hideLoader();
            if (
                res &&
                (res?.status == 200 || res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
            ) {
                setOtpErrorMsg('')
                setIsotpSent(true);
                setOtpRefId(res.result.otpId);
                showToastMsg('Success', res?.message || res?.result.message)
                eventEmitter(ORP, 'te_postpaid_bill_payment_get_otp_success', 'click', 'te_postpaid_bill_payment_get_otp_success', null);
                return
            } else {
                setOtpErrorMsg(res?.message || "something went wrong!")
                showToastMsg('Error', res?.message || "Something Went Wrong!")
                eventEmitter(ORP, 'te_postpaid_bill_payment_get_otp_failed', 'click', res?.message, null);

            }
        }).catch(error => {
            hideLoader();
            console.log('error from get otp', error)
            showToastMsg('Error', error?.error?.message || error?.message || "Something Went Wrong!")
            eventEmitter(ORP, 'te_postpaid_bill_payment_get_otp_failed', 'click', error?.error?.statusCode?.toString(), null);

        }
        )
    }

    const resendOTP = (event) => {
        event.preventDefault();
        let postRequestData = {
            otpId: otpRefId,
            flowType: FETCH_BILL_DETAILS
        };
        let postRequest = {
            data: postRequestData,
        };
        showLoader();
        resendOtp(postRequest).then(
            (res) => {
                //   this.loaderService.stopLoading();
                let data;
                res = res?.data;
                hideLoader();
                if (
                    res &&
                    (res?.status == 200 || res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
                ) {
                    setOtpErrorMsg('')
                    setOtpRefId(res?.result?.otpId);
                    showToastMsg('Success', res?.message || res?.result.message)
                    eventEmitter(ORP, 'te_postpaid_bill_payment_resend_otp_success', 'click', 'te_postpaid_bill_payment_resend_otp_success', null);
                    return;
                } else {

                    setOtpErrorMsg(res.message || "something went wrong!")
                    eventEmitter(ORP, 'te_postpaid_bill_payment_resend_otp_failed', 'click', res?.message, null);

                }
            },
            (error) => {
                //   this.loaderService.stopLoading();
                hideLoader();
                let toastData = {
                    msg: error.error.message || "something went wrong!",
                };
                eventEmitter(ORP, 'te_postpaid_bill_payment_resend_otp_failed', 'click', error?.error?.statusCode?.toString(), null);

            }
        );
    }

    const verifyOTP = (event) => {
        event.preventDefault();
        let postRequestData = {
            // typeOfNumber: "PREP",
            otp: otp,
            otpId: otpRefId,
            flowType: FETCH_BILL_DETAILS
        };
        let postRequest = {
            data: postRequestData,
        };
        showLoader();
        verifyOtp(postRequest).then(
            (res) => {
                hideLoader();
                //   this.loaderService.stopLoading();
                res = res?.data;
                if (
                    res &&
                    (res?.result?.status == 200 || res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
                ) {
                    setOtpErrorMsg('')
                    setToken(res?.result?.token)
                    fetchBillAmount(event, res?.result?.token, true);
                    eventEmitter(ORP, 'te_postpaid_bill_payment_verify_otp_success', 'click', 'te_postpaid_bill_payment_verify_otp_success', null);
                    return
                } else {
                    setOtpErrorMsg(res?.result?.message || "something went wrong!");
                    eventEmitter(ORP, 'te_postpaid_bill_payment_verify_otp_failed', 'click', res?.message, null);
                    showToastMsg('Error', res?.message || res?.result.message)

                }
            },
            (error) => {
                hideLoader();
                setOtpErrorMsg(error.error.message || "something went wrong!");
                eventEmitter(ORP, 'te_postpaid_bill_payment_verify_otp_failed', 'click', error?.error?.statusCode?.toString(), null);

            }
        );
    }

    const openAccountModal = () => {
        setShowOtpModal(false)
        setShowAccountModal(true);
        toggleModalEvent(true);
    }

    const isAccountLengthInValid = () => {
        return (!accountNumber || accountNumber?.length != process.env.REACT_APP_ACCOUNT_NUMBER_LENGTH)
    }

    const fetchViaAccount = (event) => {
        event.preventDefault();
        let postRequestData = {
            msisdn: msisdn,
            accountNo: accountNumber,
            refId: otpRefId
        };
        let postRequest = {
            data: postRequestData,
        };
        showLoader();
        validateMsidnViaAccount(postRequest).then(
            (res) => {
                hideLoader()
                // this.loaderService.stopLoading();
                let response = res?.data;
                if (
                    response && (response?.statusCode == 200 || response?.status?.toLowerCase() == "success")
                ) {
                    setAccountErrorMsgs('')
                    fetchBillAmount(event);
                    // setAccountNumber(false);
                    eventEmitter(ORP, 'te_postpaid_bill_payment_account_number_validate_success', 'click', 'te_postpaid_bill_payment_account_number_validate_success', null);
                    return
                }
                else if (response?.statusCode && (response?.statusCode === 60119 || response?.statusCode === 60005)) {
                    // this.accountMsisdnErrorFlag=true;
                    // this.accountMsisdnErrorMsg=response?.message;
                    setAccountErrorMsgs(response?.message || "something went wrong!")
                    let toastData = { msg: response?.message || "something went wrong!" };
                    // this._toaster.Error('Error',toastData?.msg);
                    eventEmitter(ORP, 'te_postpaid_bill_payment_account_number_validate_failed', 'click', response?.message, null);
                }
                else {
                    setAccountErrorMsgs(response?.message || "something went wrong!")
                    let toastData = { msg: response?.message || "something went wrong!" };
                    // this._toaster.Error('Error',toastData.msg);
                    eventEmitter(ORP, 'te_postpaid_bill_payment_account_number_validate_failed', 'click', response?.message, null);
                }
            },
            (error) => {
                hideLoader();
                // this.loaderService.stopLoading();
                let toastData = {
                    msg: error?.error?.message || "something went wrong!",
                };
                setAccountErrorMsgs(error?.error?.message || "something went wrong!")
                //   this._toaster.Error('Error',toastData.msg);
                eventEmitter(ORP, 'te_postpaid_bill_payment_account_number_validate_failed', 'click', error?.error?.statusCode?.toString(), null);

            }
        );
    }

    const fetchBillAmount = (event, tkn, fromOTPFlow = false) => {
        event.preventDefault();
        // this.loaderService.startLoading();

        let postRequestData = {
            msisdn: generateMsisdn(msisdn),
            refId: otpRefId,
            accNo: accountNumber
        };

        if (fromOTPFlow) {
            postRequestData["tkn"] = tkn ?? token
        }

        let postRequest = {
            data: postRequestData
        };

        getBillAmount(postRequest).then(
            (res) => {
                // this.loaderService.stopLoading();
                res = res?.data;
                if (
                    res &&
                    (res.statusCode == 200 || res.status.toLowerCase() == "success")
                ) {
                    setShowAccountModal(false);
                    setShowOtpModal(false);

                    setUnbilledAmout(`${process.env.REACT_APP_CURRENCY} ${res?.result?.totalOutstanding}`);
                    //   this.user.amount = res?.result?.totalOutstanding;
                    setOutstandingAmount(res?.result?.totalOutstanding)
                    billSummaryEvent(true);
                    sendBillInfo(res?.result)
                    eventEmitter(ORP, 'te_postpaid_bill_payment_fetch_bill_success', 'click', 'te_postpaid_bill_payment_fetch_bill_success', null);
                    return
                } else {
                    showToastMsg('Error', res.message || 'Something went wrong!')
                    eventEmitter(ORP, 'te_postpaid_bill_payment_fetch_bill_failed', 'click', res?.message, null);

                }
            },
            (error) => {
                // this.loaderService.stopLoading();
                let toastData = {
                    msg: error.error.message || "something went wrong!",
                };
                // this._toaster.Error(
                //     'Error', toastData.msg);
                eventEmitter(ORP, 'te_postpaid_bill_payment_fetch_bill_failed', 'click', error?.error?.statusCode?.toString(), null);

            }
        );
    }


    const showToastMsg = (type, message) => {
        setToastMsg({ type, message });
        setTimeout(() => setToastMsg(null), 3000);
    }

    return (<>
        {showOtpModal && <>
            <div id="myModal" className=" pop-up-outer adv-modal modal fade in" role="dialog">
                <div className="otp-modal">
                    {/* <!-- Modal content--> */}
                    <div className="otp-content">
                        <div className="otp-header">
                            <h3>{translation?.verifyAccount}</h3>
                            <p>{translation?.otpWillbeSent}</p>
                            <button type="button" className="close" data-dismiss="modal" onClick={() => { setShowOtpModal(false); toggleModalEvent() }}>×</button>
                            {/* <!--         <h4 className="modal-title">Modal Header</h4> --> */}
                        </div>
                        <div className="modal-body ">

                            <form>
                                <div className="form-grp">
                                    <input type="text"
                                        name="sendOtp"
                                        value={msisdn}
                                        maxLength={process.env.REACT_APP_NUMBER_MAX_LENGTH}
                                        placeholder="Mobile Number"
                                        readOnly
                                        className="form-control"
                                    />
                                    {!isOtpSent && <button className="get_otp" onClick={sendOtp}>Get OTP</button>}

                                </div>


                                {isOtpSent && <>
                                    <div className="form-grp">

                                        <input
                                            type="password"
                                            className="form-control" maxLength={6}
                                            ength="6"
                                            name="otp-number"
                                            placeholder="Enter OTP"

                                            onInput={(event) => setOtp(event?.target?.value)}
                                        />
                                    </div>
                                    {/* <p className="otp_err">  {otpErrorMsg}</p> */}
                                    <div className="receive_otp">{translation?.didntReceiveOtp}<span onClick={resendOTP}></span>{translation?.resend}</div>
                                    <div className="accountModal">
                                        <button className="fetch_account" onClick={openAccountModal}>{translation?.didntReceiveOtp} <span>{translation?.fetchViaAccount}</span></button>

                                    </div>
                                </>}
                                <button className="get_outstanding" disabled={!otp} onClick={verifyOTP}>{translation?.getOutstanding}</button>
                                <span></span>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>}
        {showAccountModal && <>
            <div id="myModal" className="pop-up-outer adv-modal modal fade in" role="dialog">
                <div className="otp-modal">
                    {/* <!-- Modal content--> */}
                    <div className="otp-content">
                        <div className="otp-header">
                            <h3>{translation?.enterAccountNo}</h3>
                            <p>{`Enter your ${process.env.REACT_APP_ACCOUNT_NUMBER_LENGTH} digit account number`} </p>
                            <button type="button" className="close" data-dismiss="modal" onClick={() => { setShowAccountModal(false); toggleModalEvent() }}>×</button>
                            {/* <!--         <h4 className="modal-title">Modal Header</h4> --> */}
                        </div>
                        <div className="modal-body ">
                            <div></div>
                            <input
                                className="form-control"
                                name="accountNumber"
                                maxLength="10"
                                placeholder="Account Number"
                                onInput={(event) => setAccountNumber(event.target.value)}
                            />
                            <p className="Otp_err error">  {accountErrorMsg} </p>
                        </div>
                        {/* add css disable calss using method isAccountLengthInValid */}
                        <div className="accountModal accountModal_account">
                            <button className="get_outstanding" onClick={fetchViaAccount} >{translation?.getOutstanding}</button>
                        </div>  </div>
                </div>
            </div>
        </>

        }
        {toastMsg && <ToastMsg message={toastMsg.message} type={toastMsg.type} onClose={() => setToastMsg(null)}></ToastMsg>}

    </>)
}

export default OtpModal;